import { sumBy } from "lodash";

export default {
  methods: {
    applyPromotions(price, promotions) {
      price = parseFloat(price);
      let discount = 0;
      promotions.map((promotion) => {
        discount += price - this.applyPromotion(price, promotion);
      });
      return price - discount;
    },
    applyPromotion(price, promotion) {
      price = parseFloat(price);
      if (!promotion) {
        return price;
      }
      if (promotion.discount_type === this.$const('discount_types', 'VALUE')) {
        price -= parseFloat(promotion.discount);
      } else {
        price -= parseFloat(price) * parseFloat(promotion.discount) / 100;
      }
      return price;
    },
    getPropertyPromotions(property, withBest) {
      let promotions = [];
      if (property.coupon) {
        promotions.push(property.coupon);
      }
      if (property.best_promotion && withBest) {
        promotions.push(property.best_promotion);
      }
      return promotions;
    },
    getRoomTypePromotions(roomType, property, withBestProperty) {
      property = property || this.property;
      let promotions = [];
      const best_promotion = this.getBestPromotion(property, roomType);
      if (best_promotion) {
        promotions.push(best_promotion);
      }
      this.getPropertyPromotions(property, withBestProperty).map((promotion) => {
        const empty = promotions.filter(item => item.id === promotion.id).length === 0;
        if (empty && (promotion.room_types.includes(roomType.id) || promotion.is_all_room_types)) {
          promotions.push(promotion);
        }
      });
      return promotions;
    },
    calculateTotalAmount(rates) {
      return sumBy(rates, (r) => {
        return parseFloat(r.amount);
      });
    },
    hasRoomTypePromotion(roomType) {
      if (!roomType || !Object.keys(roomType).length) {
        return false;
      }
      return !!this.getRoomTypePromotions(roomType).length;
    },
    isCouponValuePromotion(promotion) {
      return promotion.type === this.$const('promotion_types', 'COUPON') &&
        promotion.discount_type === this.$const('discount_types', 'VALUE');
    },
    isCouponApplied() {
      let query = this.$route.query;
      return !!query.coupon;
    },
    getBestPromotion(property, roomType) {
      let bestPromotion = null;
      if (roomType.best_promotion) {
        bestPromotion = roomType.best_promotion;
      }
      if (property.best_promotion) {
        const bestPropertyDiscount = parseFloat(property.best_promotion.discount);
        const bestRoomTypeDiscount = bestPromotion ? parseFloat(bestPromotion.discount) : 0;
        if (bestPropertyDiscount > bestRoomTypeDiscount) {
          bestPromotion = property.best_promotion;
        }
      }
      return bestPromotion;
    },
  }
}
